import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { filterPageTypes, toggleFilterTypes } from 'src/app/store/filters.era';
import { loadLocal } from 'src/app/helpers/helpers';
import { tableFilterTypes } from 'src/app/store/performers.era';
import { JoiEvent } from 'globals/store/events.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { addAnExhibitorStand, importTableData, saveTable } from '../performers/performerSharedFunctions';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { exhibitorStandColumns, ExhibitorStandsTableData } from 'src/app/helpers/table-column-types';
import { TableColumn, TableMenuItem } from 'src/app/helpers/table.data';
import { exhibitorStandColumnsById } from 'src/app/helpers/table-helpers';
import { exhibitorStandsTableReselector, exhibitorStandColumnsReselector } from 'src/app/store/reselectors/exhibitors.reselector';
import { ExhibitorStand } from 'globals/store/exhibitors.data';
import { NestedTableComponent } from './../../components/nested-table/nested-table.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ManageExhibitorStandData, ManageExhibitorStandDialogComponent } from './manage-exhibitor-stand';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'exhibitor-stands-table',
    template: `
<top-menu></top-menu>
<mobile-menu></mobile-menu>
<command-menu
  [filterPage]="filterPage"
  [filterType]="filterType"
  [filterText]="'Filter exhibitor stands'"
  [canEditColumns]="true"
  [showDottedMenu]="true"
  [showExport]="true"
  (onExport)="saveTable()"
></command-menu>
<nested-table
  [items]="tableData"
  [filtersId]="filterPage"
  [condensedView]="condensed"
  [columns]="columnData"
  [readOnly]="!event || event.is_readonly"
  [columnsById]="columnsById"
  [menuItems]="menuItems"
  [defaultSelectedColumnId]="exhibitorStandColumns.standNumber"
  (selectItem)="manageExhibitorStand($event)"
  (updatedSelectedIds)="selectIds($event)"
  [emptyMessage]="'No exhibitor stands in this event. Exhibitor stands can be created in event room/locations'"
></nested-table>
<loader-pane-fragment [trace]="traceNames.viewExhibitorStands"></loader-pane-fragment>
`,
    styleUrls: ['../../page.scss'],
    standalone: true,
    providers: [DatePipe],
    imports: [LoaderPaneFragmentComponent, NestedTableComponent, CommandMenuComponent, TopMenuComponent, MobileMenuComponent],
})
export class ExhibitorStandsTableComponent extends Wrapper<ExhibitorStandsTableComponent> {
  filterPage = filterPageTypes.exhibitor_stands
  filterType = tableFilterTypes.ExhibitorStandsTable
  exhibitorStandColumns = exhibitorStandColumns
  columnData: TableColumn[] = []
  columnsById: { [id: string]: TableColumn } = exhibitorStandColumnsById
  tableData: ExhibitorStandsTableData[] = []
  tableRowsById: { [id:string]: ExhibitorStandsTableData } = {}
  exhibitorStands: { [eId: string]: ExhibitorStand }
  traceNames = traceNames
  @ViewChild(NestedTableComponent, { static: false }) table: NestedTableComponent<ExhibitorStandsTableData>
  
  allMenuItems: TableMenuItem[] = [
    { title: 'Delete', method: this.deleteExhibitorStands.bind(this) },
    // { title: 'Duplicate', method: this.duplicateExhibitors.bind(this) }, <== NOT GOOD TO INCLUDE FOR MANY REASONS
  ]
  
  menuItems: TableMenuItem[] = this.allMenuItems // default to showing all menu items 
  condensed: boolean
  event: JoiEvent

  saveTable() {
    saveTable('exhibitor stand', `${this.event.title} exhibitor stands table`, this.dialog, this.table)
  }

  importTableData(){
    importTableData('exhibitorStand', this.dialog, this.exhibitorService.addMultipleExhibitorStands.bind(this.exhibitorService))
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.uiService.changePageTitle("Exhibitor Stands", true)
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('exhibitorStands', 'entities'), 'exhibitorStands')

    this.subProp(this.store.select(exhibitorStandColumnsReselector), 'columnData')
    this.selectCallback(exhibitorStandsTableReselector, null, (data: {
      exhibitorStandTableData: ExhibitorStandsTableData[];
      exhibitorStandTableRowsById: {
          [key: string]: ExhibitorStandsTableData;
    }}) => {
      if (!data) {
        this.tableData = [] // for when the last is deleted
        return
      }
      const { exhibitorStandTableData, exhibitorStandTableRowsById } = data
      this.tableData = exhibitorStandTableData
      this.tableRowsById = exhibitorStandTableRowsById
    })
    this.loadCondensed()
    this.subCallback(this.store.select('filters', 'toggleFilters', this.filterPage, 'condensed'), _ => this.loadCondensed())
  }


  addExhibitorStand(event) {
    console.log("NEW EXHIBITOR STAND!")
    addAnExhibitorStand(event, this.dialog, this.exhibitorService, this.manageExhibitorStand.bind(this))
  }

  setMenu() {
    setTimeout(() => {
      const selectedExhibitors = Array.from(this.table.selectedIds).map(id => this.exhibitorStands[id])
      this.menuItems = [...this.allMenuItems]
    }, 0)
  }

  selectIds(ids: Set<string>) {
    this.setMenu()
  }

  async duplicateExhibitorStands(toDuplicate, event) { // not in use as multiple duplicates at one time can lead to crazy results
    const data: ConfirmDeleteData = {
      title: `Duplicate ${toDuplicate.length} exhibitor stand${toDuplicate.length === 1 ? '' : 's'}`,
      rect: event.target.getBoundingClientRect(),
      para: `Are you sure you want to duplicate ${toDuplicate.length > 1 ? `all ${toDuplicate.length} selected exhibitor stands` : 'the selected exhibitor stand'}?`,
      dialog: this.dialog,
      deleteButtonText: 'DUPLICATE',
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.exhibitorService.duplicateExhibitorStands(toDuplicate.map(({ exhibitorStand }) => exhibitorStand))
  }

  async manageExhibitorStand({ id }: ExhibitorStandsTableData) {
    console.log(`Should be opening the manage exhibitor stand dialog for exhibitor stand ${id}`)
    const data: ManageExhibitorStandData = { exhibitorStandId: id }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageExhibitorStandDialogComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  async deleteExhibitorStands(toDelete: ExhibitorStandsTableData[], event) {
    const data: ConfirmDeleteData = {
      title: `Delete ${toDelete.length} exhibitor stands`,
      rect: event.target.getBoundingClientRect(),
      para: `Are you sure you want to delete ${toDelete.length > 1 ? `all ${toDelete.length} selected exhibitor stands` : 'the selected exhibitor stand'}?`,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.exhibitorService.deleteExhibitorStands(toDelete.map(({ exhibitorStand }) => exhibitorStand))
  }

  loadCondensed() {
    this.condensed = loadLocal(`${this.filterPage}:${toggleFilterTypes.condensed}`, false)
  }

}
